import ExpenditureDetails from "./ExpenditureDetails";


export{ExpenditureDetails}